export default __webpack_public_path__ + "static/media/profileLogo.8f17d690.png";